import { useTranslation } from "react-i18next";
import { Props, PositionWithoutActivityOptionValue, PositionWithoutActivityQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const PositionWithoutActivityQuickfilter = <Q extends PositionWithoutActivityQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.activity"; // tRP - translation root path

  const options: QuickFilterOption<PositionWithoutActivityOptionValue>[] = [
    {
      name: t(`${tRP}.with_and_without_activity`),
      value: { daysWithoutActivity: null },
    },
    {
      name: t(`${tRP}.without_activity_for_the_last_15_days`),
      value: { daysWithoutActivity: 15 },
    },
    {
      name: t(`${tRP}.without_activity_for_the_last_30_days`),
      value: { daysWithoutActivity: 30 },
    },
    {
      name: t(`${tRP}.without_activity_for_the_last_45_days`),
      value: { daysWithoutActivity: 45 },
    },
  ];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="positionWithoutActivity"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
    />
  );
};
